<template>
  <mdb-container fluid v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px">
      <strong>{{ TitleHeader }}</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div class="price white-text rounded-top" v-bind:style="{
          padding: '1rem 2rem',
          textAlign: 'left',
          background: '#026ab4',
          fontFamily: 'OpenSans-Regular',
          fontSize: '16px',
          lineHeight: '1.38',
        }">
          <span>
            <img alt="icono nuevo residente"
              src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png"
              class="img-fluid" style="width: 28px; height: 26px" />
          </span>
          &nbsp; {{ TitleHeader }}
          <div class="text-right" style="margin-top: -10px; margin-right: -20px; float: right">
            <mdb-tooltip v-show="!isEdit" material trigger="hover" :options="{ placement: 'top' }">
              <span slot="tip">Importar desde excel</span>
              <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 style_BTN"
                @click="handleShowModal">
                <mdb-icon icon="file-excel" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
            <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
              <span slot="tip">Descartar registro</span>
              <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 style_BTN" @click="remove">
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>
        <!--/Card image-->
        <!--Card content-->
        <mdb-card-body>
          <form id="form2" class="needs-validation" novalidate @submit="checkFormResident">
            <mdb-row class="form-row">
              <!--Form content-->
              <!-- Columna 1: Datos personales -->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos personales</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="firtsName" style="font-family: OpenSans-Semibold; font-size: 12px">Nombre</label>
                      <input type="text" class="form-control text-input" id="firstName" required placeholder="Nombre"
                        maxlength="64" v-model="form.firstName" style="
                          height: 37px;
                          margin-top: 10px;
                          font-size: 12px;
                          width: 100%;
                        " />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="lastName" style="font-family: OpenSans-Semibold; font-size: 12px">Apellidos</label>
                      <input type="text" class="form-control text-input" id="lastName" required placeholder="Apellidos"
                        maxlength="64" v-model="form.lastName" style="
                          height: 37px;
                          margin-top: 10px;
                          font-size: 12px;
                          width: 100%;
                        " />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="email" style="
                          font-family: OpenSans-Semibold;
                          font-size: 12px;
                          width: 100%;
                        ">Correo electrónico</label>
                      <input type="text" class="form-control text-input" id="email" required
                        pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" placeholder="Correo electrónico"
                        maxlength="64" v-model="form.email" @blur="validateEmail" style="
                          height: 37px;
                          margin-top: 10px;
                          font-size: 12px;
                          width: 100%;
                        " />
                      <div class="valid-feedback">Correcto</div>
                      <div class="invalid-feedback">
                        Por favor, introduzca un correo con formato
                        email@example.com
                      </div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="phone" style="font-family: OpenSans-Semibold; font-size: 12px">
                        Teléfonos
                        <span style="font-family: OpenSans-Regular; font-size: 11px; color: #a09c9c;">
                          ({{ activePhones.length }}/4)
                        </span>
                      </label>

                      <!-- Lista de teléfonos como chips -->
                      <div v-if="activePhones.length > 0" class="phones-chip-container">
                        <template v-for="(phone, index) in phones">
                          <!-- Modo edición inline -->
                          <div v-if="phone.number !== '' && editingPhoneIndex === index"
                            :key="'edit-' + index" class="phone-chip-edit-row">
                            <model-select :options="ladaOptions" v-model="editingPhoneCode"
                              placeholder="Lada" class="lada-model-select lada-model-select-sm" />
                            <input type="text" inputmode="numeric" v-model="editingPhoneNumber"
                              class="form-control text-input phone-input"
                              :maxlength="editingPhoneLadaDigits"
                              :placeholder="`${editingPhoneLadaDigits} dígitos`"
                              @keypress="onlyDigits"
                              style="height: 30px; font-size: 12px; flex: 1;" />
                            <mdb-icon icon="check" class="phone-edit-confirm" @click.native="savePhoneEdit(index)" />
                            <mdb-icon icon="times" class="phone-edit-cancel-icon" @click.native="cancelPhoneEdit" />
                          </div>
                          <!-- Chip normal -->
                          <div v-else-if="phone.number !== ''"
                            :key="'phone-' + index" class="phone-chip">
                            <mdb-icon icon="phone" class="phone-chip-icon" />
                            <span class="phone-chip-number">{{ phone.code || '+52' }} · {{ phone.number }}</span>
                            <mdb-icon icon="edit" class="phone-chip-edit-icon" @click.native="startPhoneEdit(index)" />
                            <mdb-icon icon="times" class="phone-chip-delete" @click.native="deletePhone(index)" />
                          </div>
                        </template>
                      </div>

                      <!-- Input para agregar nuevo teléfono -->
                      <div v-if="countPhone < 4" class="phone-input-group" style="margin-top: 10px;">
                        <model-select :options="ladaOptions" v-model="newPhoneLada"
                          placeholder="Lada" class="lada-model-select" />
                        <input type="text" inputmode="numeric" class="form-control text-input phone-input"
                          :placeholder="`${newPhoneLadaDigits} dígitos`"
                          :maxlength="newPhoneLadaDigits"
                          v-model="newPhoneInput"
                          @keypress.enter.prevent="addPhoneFromInput"
                          @keypress="onlyDigits"
                          style="height: 37px; font-size: 12px; flex: 1;" />
                        <mdb-btn type="button" outline rounded size="sm" style="
                            background-color: #00a65a;
                            border-color: #008d4c;
                            color: #ffffff;
                            width: 37px;
                            height: 37px;
                            padding: 0;
                            margin-left: 8px;
                            flex-shrink: 0;
                          " @click="addPhoneFromInput">
                          <mdb-icon icon="plus" class="mt-0" />
                        </mdb-btn>
                      </div>

                      <small v-if="countPhone >= 4"
                        style="color: #a09c9c; font-family: OpenSans-Regular; font-size: 11px;">
                        Máximo de teléfonos alcanzado
                      </small>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>

              <!-- Columna 2: Dirección -->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Dirección</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold">Zona</label>
                      <model-select :options="zonesList" v-model="zoneModel" placeholder="Selecciona una zona"
                        :isError="zoneValid"></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold">Calle</label>
                      <model-select :options="streetList" v-model="streetModel" placeholder="Selecciona una calle"
                        :isError="streetValid"></model-select>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold">Número exterior</label>
                      <input type="number" class="form-control text-input" id="number" required
                        placeholder="Número de casa" maxlength="8" v-model="form.numberStreet" style="
                          height: 37px;
                          margin-top: 10px;
                          font-size: 12px;
                          width: 100%;
                        " />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label style="font-family: OpenSans-Semibold">Número interior</label>
                      <input type="text" class="form-control text-input" id="number" placeholder="Número interior"
                        maxlength="8" v-model="intNumber" style="
                          height: 37px;
                          margin-top: 10px;
                          font-size: 12px;
                          width: 100%;
                        " />
                      <!-- <div class="valid-feedback">Correcto</div> -->
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>

              <!-- Columna 3: Configuración y Reconocimiento Facial -->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Configuración</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row v-if="isMe.frac == 'Club Tres Marias'">
                  <mdb-col md="11">
                    <div class="form-group">
                      <label for="phone" style="font-family: OpenSans-Semibold; font-size: 12px">No. de acción</label>
                      <input type="number" class="form-control text-input" id="phone" placeholder="No. de Acción"
                        maxlength="10" v-model="Naccion" style="
                          height: 37px;
                          margin-top: 10px;
                          font-size: 12px;
                          width: 100%;
                        " />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group custom-checkbox"
                      :style="isMe.frac == 'Club Tres Marias' ? '' : 'margin-top: 2rem'">
                      <input type="checkbox" class="form-control form-check-input" id="defaultUnchecked"
                        v-model="useApp" />
                      <label class="form-check-label" for="defaultUnchecked">Usar app de residentes</label>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row v-if="hasFacialRecognition">
                  <mdb-col md="11">
                    <div class="form-group" style="margin-top: 1.5rem">
                      <label style="font-family: OpenSans-Semibold; font-size: 12px">
                        Reconocimiento facial
                        <span v-if="faceImageRecognition && faceImageRecognition.active" class="face-label-status"
                          style="color: #49a704;">
                          ✓
                        </span>
                      </label>

                      <!-- Vista cuando NO hay imagen -->
                      <div v-if="!faceImageRecognition || !faceImageRecognition.s3Url" class="face-upload-area">
                        <!-- Placeholder deshabilitado cuando es nuevo residente -->
                        <div v-if="!isEdit" class="face-upload-placeholder face-upload-disabled">
                          <mdb-icon icon="camera" class="face-upload-icon" style="color: #c0c0c0;" />
                          <p class="face-upload-text" style="color: #a09c9c;">Subir foto facial</p>
                          <small class="face-upload-disabled-msg">
                            Primero registra al residente para poder agregar su foto facial
                          </small>
                        </div>

                        <template v-else>
                          <input type="file" ref="faceImageInput" accept="image/jpeg,image/jpg,image/png"
                            @change="handleFaceImageSelect" style="display: none" />

                          <!-- Loader mientras carga la previsualización -->
                          <div v-if="loadingPreview" class="face-preview-selected">
                            <div class="face-loader-container">
                              <div class="face-loader-spinner"></div>
                              <p class="face-loader-text">Cargando imagen...</p>
                            </div>
                          </div>

                          <!-- Preview de imagen seleccionada pero no guardada -->
                          <div v-else-if="selectedFaceImage" class="face-preview-selected">
                            <div class="face-preview-img-container">
                              <img :src="selectedFaceImagePreview" class="face-preview-img"
                                @click="openFullScreenPreview(selectedFaceImagePreview)" />
                              <div class="face-preview-overlay" @click="openFullScreenPreview(selectedFaceImagePreview)">
                                <mdb-icon icon="search-plus" class="face-preview-zoom-icon" />
                              </div>
                            </div>
                            <div class="face-preview-actions">
                              <mdb-btn type="button" size="sm" color="danger" @click="cancelFaceImageSelection">
                                Cancelar
                              </mdb-btn>
                              <mdb-btn type="button" size="sm" style="background-color: #00a65a; border-color: #008d4c;"
                                @click="uploadFaceImage" :disabled="uploadingFaceImage">
                                {{ uploadingFaceImage ? 'Subiendo...' : 'Guardar' }}
                              </mdb-btn>
                            </div>
                          </div>

                          <!-- Placeholder cuando no hay imagen seleccionada -->
                          <div v-else class="face-upload-placeholder" @click="$refs.faceImageInput.click()">
                            <mdb-icon icon="camera" class="face-upload-icon" />
                            <p class="face-upload-text">Subir foto facial</p>
                            <small class="face-upload-hint">JPG, JPEG o PNG - Máx. 5MB</small>
                          </div>
                        </template>
                      </div>

                      <!-- Vista cuando SÍ hay imagen guardada -->
                      <div v-else class="face-image-preview">
                        <!-- Loader mientras carga la previsualización al editar -->
                        <div v-if="loadingPreview">
                          <div class="face-loader-container">
                            <div class="face-loader-spinner"></div>
                            <p class="face-loader-text">Cargando imagen...</p>
                          </div>
                        </div>

                        <!-- Si está editando la imagen existente -->
                        <div v-else-if="selectedFaceImage">
                          <div class="face-preview-img-container">
                            <img :src="selectedFaceImagePreview" class="face-preview-img"
                              @click="openFullScreenPreview(selectedFaceImagePreview)" />
                            <div class="face-preview-overlay" @click="openFullScreenPreview(selectedFaceImagePreview)">
                              <mdb-icon icon="search-plus" class="face-preview-zoom-icon" />
                            </div>
                          </div>
                          <div class="face-preview-actions">
                            <mdb-btn type="button" size="sm" color="danger" @click="cancelFaceImageSelection">
                              Cancelar
                            </mdb-btn>
                            <mdb-btn type="button" size="sm" style="background-color: #00a65a; border-color: #008d4c;"
                              @click="updateFaceImage" :disabled="uploadingFaceImage">
                              {{ uploadingFaceImage ? 'Actualizando...' : 'Actualizar' }}
                            </mdb-btn>
                          </div>
                        </div>

                        <!-- Vista normal de la imagen guardada -->
                        <div v-else>
                          <div class="face-preview-header">
                            <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                              <span slot="tip">Cambiar foto</span>
                              <mdb-btn slot="reference" type="button" outline rounded size="sm" style="
                                background-color: #00a65a !important;
                                border-color: #008d4c !important;
                                color: #ffffff !important;
                                width: 32px;
                                height: 32px;
                                padding: 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                              " @click="$refs.faceImageInputEdit.click()">
                                <mdb-icon icon="edit" style="color: #ffffff !important;" />
                              </mdb-btn>
                            </mdb-tooltip>
                            <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                              <span slot="tip">Eliminar foto</span>
                              <mdb-btn slot="reference" type="button" outline="danger" rounded size="sm"
                                class="face-action-btn" @click="confirmDeleteFaceImage">
                                <mdb-icon icon="trash" />
                              </mdb-btn>
                            </mdb-tooltip>
                          </div>

                          <div class="face-preview-img-container">
                            <img :src="getFaceImageUrl()" :alt="faceImageRecognition.originalFilename"
                              class="face-preview-img" :key="faceImageKey"
                              @click="openFullScreenPreview(getFaceImageUrl())" />
                            <div class="face-preview-overlay" @click="openFullScreenPreview(getFaceImageUrl())">
                              <mdb-icon icon="search-plus" class="face-preview-zoom-icon" />
                            </div>
                          </div>

                          <div class="face-image-info">
                            <p class="face-filename">{{ faceImageRecognition.originalFilename }}</p>
                            <span class="face-status-badge" :class="getFacialStatusClass()">
                              {{ getFacialStatusText() }}
                            </span>
                          </div>
                        </div>

                        <!-- Input oculto para cambiar imagen -->
                        <input type="file" ref="faceImageInputEdit" accept="image/jpeg,image/jpg,image/png"
                          @change="handleFaceImageSelect" style="display: none" />
                      </div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row class="form-row">
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group"></div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row style="padding-left: 35%">
              <mdb-col md="2">
                <button type="button" class="waves-effect waves-dark btn btn-next btn-color-prev" @click="remove()">
                  Cancelar
                </button>
              </mdb-col>
              <mdb-col md="2">
                <mdb-btn type="submit" class="waves-effect waves-dark btn btn-next btn-color-next">{{ TextButton
                }}</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
    <mdb-modal :show="showModal" @close="closeModal()" size="lg">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff">Importar desde excel</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-row>
          <mdb-col md="6">
            <div class="md-form mb-0">
              <span>1.- Descarga la plantilla de residentes</span>
            </div>
          </mdb-col>
          <mdb-col md="6">
            <div class="md-form mb-0">
              <span>2.- Adjunta la plantilla de residentes</span>
            </div>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="6">
            <div class="md-form mb-0">
              <a v-if="isMe.frac == 'Club Tres Marias'" :href="imgServer +
                'apps/myfrac/admin/assets/ejemplo_residente_TresMarias.xlsx'
                " class="btn btn-verde" role="button" style="
                  font-family: OpenSans-Semibold;
                  font-size: 12px;
                  width: 137px;
                  height: 45px;
                  text-transform: capitalize;
                  object-fit: contain;
                " download>Descargar</a>
              <a v-else :href="imgServer + 'apps/myfrac/admin/assets/ejemplo_residente.xlsx'
                " class="btn btn-verde" role="button" style="
                  font-family: OpenSans-Semibold;
                  font-size: 12px;
                  width: 137px;
                  height: 45px;
                  text-transform: capitalize;
                  object-fit: contain;
                " download>Descargar</a>
            </div>
          </mdb-col>
          <mdb-col md="6">
            <div v-show="!uploadingCSV && !uploadSuccess">
              <div class="row center-align" style="margin-bottom: 10px">
                <div class="col s12 m12 l12"></div>
              </div>
              <div class="row">
                <div class="form-csv">
                  <form enctype="multipart/form-data" id="fileUploadForm">
                    <input id="file_csv" name="file" type="file" accept=".xlsx" ref="fileupload"
                      @change="signalChange" />
                    <div id="csv-success" class="center-align ml-3 mr-3" style="
                        font-size: 12px;
                        text-align: center;
                        margin-top: 15%;
                        color: #a09c9c;
                      ">
                      <i class="far fa-copy" style="
                          padding: 15px 10px;
                          font-size: 30px;
                          color: #e8e9ec;
                        "></i>
                      <br />Arrastra la plantilla aquí o
                      <u style="color: blue">
                        <span style="color: blue">adjúntala desde tu computadora</span>
                      </u>
                    </div>
                    <h6 id="csv-failed" class="center-align" style="display: none">
                      <u style="color: red">
                        <span style="color: red">Intenta de nuevo</span>
                      </u>
                    </h6>
                  </form>
                </div>
              </div>
            </div>
            <div v-show="uploadingCSV && !uploadSuccess">
              <div class="row" style="margin-bottom: 25%"></div>
              <div class="row center-align">
                <h4 style="color: #5d6078">Importando Lista</h4>
                <h5 style="color: #5d6078">Espera un momento</h5>
                <div class="progress">
                  <div class="indeterminate"></div>
                </div>
              </div>
            </div>
            <div v-show="!uploadingCSV && uploadSuccess">
              <div class="row center-align" v-show="badlist">
                <div class="col s12 m12 l12">
                  <p style="font-size: 20px; margin: 0">
                    Algunos residentes no se pudieron insertar.
                    <a style="cursor: pointer" onclick="downloadbadExcel()">Descargar</a>
                  </p>
                  <ul style="margin: 0">
                    Causas
                  </ul>
                </div>
              </div>
              <div class="row center-align csvuploadsuccess">
                <h4 style="color: #5d6078; padding-top: 15%">
                  Lista importada exitosamente
                </h4>
                <h5 style="color: #5d6078">
                  Los residentes fueron agregados con éxito
                </h5>
              </div>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
    </mdb-modal>

    <!-- Modal de previsualización en pantalla completa -->
    <div v-if="showFullScreenPreview" class="fullscreen-preview-modal" @click="closeFullScreenPreview">
      <div class="fullscreen-preview-content">
        <button class="fullscreen-close-btn" @click="closeFullScreenPreview">
          <mdb-icon icon="times" />
        </button>
        <img :src="fullScreenImageUrl" class="fullscreen-preview-img" @click.stop />
      </div>
    </div>

    <Loader v-show="isLoading" />
  </mdb-container>
</template>
<script>
/* eslint-disable */
import { ModelSelect } from "vue-search-select";
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { mapGetters, mapActions } from "vuex";
import Loader from "../../core/Loader";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
} from "mdbvue";
import { showErrorAlert } from "../../utils/alerts.js";

const COUNTRY_CODES = [
  { code: "+52",  flag: "🇲🇽", name: "México",        digits: 10 },
  { code: "+1",   flag: "🇺🇸", name: "EE.UU./Canadá", digits: 10 },
  { code: "+502", flag: "🇬🇹", name: "Guatemala",     digits: 8  },
  { code: "+503", flag: "🇸🇻", name: "El Salvador",   digits: 8  },
  { code: "+504", flag: "🇭🇳", name: "Honduras",      digits: 8  },
  { code: "+505", flag: "🇳🇮", name: "Nicaragua",     digits: 8  },
  { code: "+506", flag: "🇨🇷", name: "Costa Rica",    digits: 8  },
  { code: "+507", flag: "🇵🇦", name: "Panamá",        digits: 7  },
  { code: "+501", flag: "🇧🇿", name: "Belice",        digits: 7  },
  { code: "+53",  flag: "🇨🇺", name: "Cuba",          digits: 8  },
];

export default {
  name: "createResident",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    Loader,
    ModelSelect,
  },
  data() {
    return {
      countPhone: 1,
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      showModal: false,
      uploadingCSV: false,
      uploadSuccess: false,
      residentsFile: "",
      badlist: false,
      excel2json: [],
      excel2jsonFail: [],
      TextButton: "Registrar",
      TitleHeader: "Alta residente",
      form: {
        firstName: "",
        lastName: "",
        email: "",
        numberStreet: "",
        phone: "",
      },
      phones: [
        { uuid: "", code: "+52", number: "" },
        { uuid: "", code: "+52", number: "" },
        { uuid: "", code: "+52", number: "" },
        { uuid: "", code: "+52", number: "" },
      ],
      useApp: false,
      Naccion: "",
      intNumber: "",
      zonesList: [],
      zoneModel: {
        value: "",
        uuid: "",
        text: "",
      },
      zoneValid: false,
      streetList: [],
      streetModel: {
        value: "",
        uuid: "",
        text: "",
      },
      streetValid: false,
      isLoading: false,
      faceImageRecognition: null,
      newPhoneInput: "",
      newPhoneLada: { value: "+52", text: "🇲🇽 +52" },
      countryCodes: COUNTRY_CODES,
      editingPhoneIndex: null,
      editingPhoneCode: { value: "+52", text: "🇲🇽 +52" },
      editingPhoneNumber: "",
      selectedFaceImage: null,
      selectedFaceImagePreview: null,
      uploadingFaceImage: false,
      loadingPreview: false, // Estado de carga de la previsualización
      faceImageKey: Date.now(), // Key para forzar re-render de la imagen
      showFullScreenPreview: false, // Control del modal de pantalla completa
      fullScreenImageUrl: '', // URL de la imagen a mostrar en pantalla completa
    }; // END RETURN
  },
  methods: {
    ...mapActions(["createResident", "editResident"]),
    closeModal() {
      this.showModal = false;
      this.streetList = [];
      this.residentsFile = "";
    },
    getOneResident() {
      console.log(this.residentValue);
      if (this.isEdit) {
        this.TextButton = "Guardar";
        this.TitleHeader = "Editar residente";

        this.zoneModel = {
          value: this.residentValue.testStreet.testZone.idZone,
          uuid: this.residentValue.testStreet.testZone.uuid,
          text: this.residentValue.testStreet.testZone.name,
        };

        this.streetModel = {
          value: this.residentValue.testStreet.idStreet,
          uuid: this.residentValue.testStreet.uuid,
          text: this.residentValue.testStreet.name,
        };

        (this.useApp = this.residentValue.useapp),
          this.residentValue.action == null
            ? (this.Naccion = "")
            : (this.Naccion = this.residentValue.action);

        var listPhones = this.residentValue.phones;
        this.countPhone = 0;
        if (listPhones.length > 0) {
          for (var i = 0; i < listPhones.length; i++) {
            this.phones[i].number = listPhones[i].phone;
            this.phones[i].uuid = listPhones[i].uuid;
            this.phones[i].code = listPhones[i].code || "+52";
            this.countPhone++;
          }
        }
        this.form = {
          firstName: this.residentValue.firstName,
          lastName: this.residentValue.lastName,
          phone: this.phones ? this.phones[0].number : "",
          email: this.residentValue.email,
          numberStreet: this.residentValue.number,
        };
        this.intNumber = this.residentValue.intNumber;

        // Cargar información de reconocimiento facial si existe
        if (this.residentValue.faceImageRecognition) {
          this.faceImageRecognition = this.residentValue.faceImageRecognition;
          // Actualizar el key para forzar carga fresca de la imagen
          this.faceImageKey = Date.now();
        }
      }
    },
    getFacialStatusText() {
      if (!this.faceImageRecognition) return "";

      const status = this.faceImageRecognition.reviewStatus;
      const statusMap = {
        'APPROVED': 'Aprobado',
        'PENDING': 'Pendiente',
        'REJECTED': 'Rechazado',
        'READY': 'Listo'
      };
      return statusMap[status] || status;
    },
    getFacialStatusClass() {
      if (!this.faceImageRecognition) return "";

      const status = this.faceImageRecognition.reviewStatus;
      return {
        'status-approved': status === 'APPROVED',
        'status-pending': status === 'PENDING',
        'status-rejected': status === 'REJECTED',
        'status-ready': status === 'READY'
      };
    },
    getFaceImageUrl() {
      if (!this.faceImageRecognition || !this.faceImageRecognition.s3Url) return '';
      // Agregar timestamp como query parameter para evitar caché del navegador
      return `${this.faceImageRecognition.s3Url}?t=${this.faceImageKey}`;
    },
    openFullScreenPreview(imageUrl) {
      this.fullScreenImageUrl = imageUrl;
      this.showFullScreenPreview = true;
    },
    closeFullScreenPreview() {
      this.showFullScreenPreview = false;
      this.fullScreenImageUrl = '';
    },
    // ========== MÉTODOS PARA RECONOCIMIENTO FACIAL ==========
    handleFaceImageSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Validar tipo de archivo
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        Swal.fire({
          title: 'Formato inválido',
          text: 'Solo se permiten archivos JPG, JPEG o PNG',
          type: 'warning',
          confirmButtonText: 'Aceptar',
        });
        event.target.value = '';
        return;
      }

      // Validar tamaño (5MB máx)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Archivo muy grande',
          text: 'El tamaño máximo permitido es 5MB',
          type: 'warning',
          confirmButtonText: 'Aceptar',
        });
        event.target.value = '';
        return;
      }

      // Crear preview con loader
      this.selectedFaceImage = file;
      this.loadingPreview = true; // Activar loader
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedFaceImagePreview = e.target.result;
        // Dar un pequeño delay para que se vea el loader
        setTimeout(() => {
          this.loadingPreview = false;
        }, 300);
      };
      reader.readAsDataURL(file);
    },
    cancelFaceImageSelection() {
      this.selectedFaceImage = null;
      this.selectedFaceImagePreview = null;
      this.loadingPreview = false;
      if (this.$refs.faceImageInput) {
        this.$refs.faceImageInput.value = '';
      }
      if (this.$refs.faceImageInputEdit) {
        this.$refs.faceImageInputEdit.value = '';
      }
    },
    async uploadFaceImage() {
      if (!this.selectedFaceImage) return;

      // Validar que el residente esté guardado
      if (!this.isEdit || !this.residentValue.uuid) {
        Swal.fire({
          title: 'Residente no guardado',
          text: 'Debes guardar el residente antes de subir una foto facial',
          type: 'warning',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      try {
        this.uploadingFaceImage = true;

        const formData = new FormData();
        formData.append('image', this.selectedFaceImage);

        const uploadUrl = `${Servers.serverApi}api/residents/facial-recognition/${this.residentValue.uuid}`;
        const response = await Axios.post(
          uploadUrl,
          formData,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        // Actualizar el objeto faceImageRecognition con la respuesta
        this.faceImageRecognition = response.data;

        // Actualizar el key para forzar re-render y evitar caché
        this.faceImageKey = Date.now();

        this.cancelFaceImageSelection();

        Swal.fire({
          title: 'Foto guardada',
          text: 'La foto facial se ha guardado correctamente',
          type: 'success',
          confirmButtonText: 'Aceptar',
        });

      } catch (error) {
        console.error('Error uploading face image:', error);
        Swal.fire({
          title: 'Error al subir foto',
          text: error.response?.data?.message || 'No se pudo guardar la foto facial',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.uploadingFaceImage = false;
      }
    },
    confirmDeleteFaceImage() {
      Swal.fire({
        title: '¿Eliminar foto facial?',
        text: 'Esta acción no se puede deshacer',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.deleteFaceImage();
        }
      });
    },
    async deleteFaceImage() {
      if (!this.residentValue || !this.residentValue.uuid) return;

      try {
        this.isLoading = true;

        await Axios.delete(
          `${Servers.serverApi}api/residents/facial-recognition/${this.residentValue.uuid}`,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
            },
          }
        );

        // Limpiar el objeto
        this.faceImageRecognition = null;

        Swal.fire({
          title: 'Foto eliminada',
          text: 'La foto facial se ha eliminado correctamente',
          type: 'success',
          confirmButtonText: 'Aceptar',
        });

      } catch (error) {
        console.error('Error deleting face image:', error);
        Swal.fire({
          title: 'Error al eliminar',
          text: error.response?.data?.message || 'No se pudo eliminar la foto facial',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.isLoading = false;
      }
    },
    async updateFaceImage() {
      // Método para cuando se cambia/edita una imagen existente
      if (!this.selectedFaceImage || !this.residentValue || !this.residentValue.uuid) return;

      try {
        this.uploadingFaceImage = true;

        const formData = new FormData();
        formData.append('image', this.selectedFaceImage);

        const response = await Axios.post(
          `${Servers.serverApi}api/residents/facial-recognition/${this.residentValue.uuid}`,
          formData,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        // Actualizar el objeto
        this.faceImageRecognition = response.data;

        // Actualizar el key para forzar re-render y evitar caché
        this.faceImageKey = Date.now();

        this.cancelFaceImageSelection();

        Swal.fire({
          title: 'Foto actualizada',
          text: 'La foto facial se ha actualizado correctamente',
          type: 'success',
          confirmButtonText: 'Aceptar',
        });

      } catch (error) {
        console.error('Error updating face image:', error);
        Swal.fire({
          title: 'Error al actualizar',
          text: error.response?.data?.message || 'No se pudo actualizar la foto facial',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.uploadingFaceImage = false;
      }
    },
    remove() {
      var obj = [];
      this.$store.commit("setResident", obj);
      this.$store.commit("setEditResident", false);
      window.location.href = "/residents";
    },
    getZones() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/zones", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
        .then(function (response) {
          aux.zonesList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idZone,
              uuid: response.data[i].uuid,
              text: response.data[i].name,
            };
            aux.zonesList.push(temp);
          }
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    getAllStreets() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/streets/", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
        .then(function (response) {
          aux.streetList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idStreet,
              uuid: response.data[i].uuid,
              text: response.data[i].name,
            };
            aux.streetList.push(temp);
          }
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    getStreets(zoneUuid) {
      let aux = this;
      Axios.get(Servers.serverApi + "api/streets/zones/" + zoneUuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
        .then(function (response) {
          aux.streetList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idStreet,
              uuid: response.data[i].uuid,
              text: response.data[i].name,
            };
            aux.streetList.push(temp);
          }
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    cleanForm() { },
    validateForm() {
      return (
        Object.keys(this.form).length ===
        Object.keys(this.form).filter((key) => {
          return this.form[key].length > 0;
        }).length
      );
    },
    async validateEmail() {
      if (!this.form.email) return;

      var request = {
        email: this.form.email,
      }

      if (this.isEdit) {
        request.residentUuid = this.residentValue.uuid
      }

      try {
        const response = await Axios.post(
          Servers.serverApi + "api/residents/validateEmail/",
          request,
          {
            // responseType: "application/json",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("access_token"),
            },
          });
        // Asumiendo que la respuesta tiene un campo 'isValid'
        const { Success, Message, Data } = response.data;
        if (!Success) {
          Data.residentStatus === "DELETED" && !this.isEdit ?
            this.showMessageInvalidEmail(Message) :
            this.showMessageError(
              "Correo ya existente.",
              Message
            );
        }

      } catch (error) {
        console.error('Error al validar el correo electrónico:', error);
        this.modalMessage = 'Hubo un error al validar el correo electrónico.';
        this.$refs.emailModal.show();
      }
    },
    async reactivateEmail(email) {
      if (!email) return;

      var request = {
        email: email,
      }

      try {
        const response = await Axios.post(
          Servers.serverApi + "api/residents/reactivateEmail/",
          request,
          {
            // responseType: "application/json",
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("access_token"),
            },
          });
        // Asumiendo que la respuesta tiene un campo 'isValid'
        const { Success, Message, Data } = response.data;
        if (Success) {

          var found = Data.resident;
          this.$store.commit("setResident", found);
          this.$store.commit("setEditResident", true);
          this.getOneResident();
          this.isLoading = false;

        }

      } catch (error) {
        console.error('Error al validar el correo electrónico:', error);
        this.modalMessage = 'Hubo un error al validar el correo electrónico.';
        this.$refs.emailModal.show();
      }

    },
    checkFormResident(event) {
      event.preventDefault();

      // Validar teléfono ANTES de marcar el formulario como validado
      if (!this.phones[0].number || this.phones[0].number === "") {
        Swal.fire({
          title: "Teléfono requerido",
          text: "Debes agregar al menos un número de teléfono válido",
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      // Validar zona
      if (this.zoneModel.value) {
        this.zoneValid = false;
      } else {
        this.zoneValid = true;
      }

      // Validar calle
      if (this.streetModel.value) {
        this.streetValid = false;
      } else {
        this.streetValid = true;
      }

      // Validar formulario
      this.form.phone = this.phones[0].number;
      var valid = this.validateForm();

      // Validar zona y calle
      if (this.zoneValid) {
        Swal.fire({
          title: "Zona requerida",
          text: "Debes seleccionar una zona",
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (this.streetValid) {
        Swal.fire({
          title: "Calle requerida",
          text: "Debes seleccionar una calle",
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      // Marcar formulario como validado solo si pasa las validaciones previas
      event.target.classList.add("was-validated");

      // Si todo es válido, proceder a guardar
      if (!this.zoneValid && !this.streetValid && valid && this.phones[0].number != "") {
        if (this.isEdit) {
          //ACTUALIZAR RESIDENTE
          this.putResident();
        } else {
          this.postResident();
        }
      }
    },
    onlyDigits(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    startPhoneEdit(index) {
      this.editingPhoneIndex = index;
      const code = this.phones[index].code || "+52";
      const country = COUNTRY_CODES.find(c => c.code === code) || COUNTRY_CODES[0];
      this.editingPhoneCode = { value: country.code, text: `${country.flag} ${country.code}` };
      this.editingPhoneNumber = this.phones[index].number;
    },
    savePhoneEdit(index) {
      const country = COUNTRY_CODES.find(c => c.code === this.editingPhoneCode.value) || COUNTRY_CODES[0];
      if (!this.editingPhoneNumber || this.editingPhoneNumber.length < country.digits) {
        Swal.fire({
          title: "Teléfono inválido",
          text: `El número para ${country.name} debe tener ${country.digits} dígitos`,
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      this.phones[index].code = this.editingPhoneCode.value;
      this.phones[index].number = this.editingPhoneNumber;
      this.cancelPhoneEdit();
    },
    cancelPhoneEdit() {
      this.editingPhoneIndex = null;
      this.editingPhoneCode = { value: "+52", text: "🇲🇽 +52" };
      this.editingPhoneNumber = "";
    },
    addPhoneFromInput() {
      const country = COUNTRY_CODES.find(c => c.code === this.newPhoneLada.value) || COUNTRY_CODES[0];
      const requiredDigits = country.digits;

      if (!this.newPhoneInput || this.newPhoneInput.length < requiredDigits) {
        Swal.fire({
          title: "Teléfono inválido",
          text: `El número para ${country.name} debe tener ${requiredDigits} dígitos`,
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      for (let i = 0; i < this.phones.length; i++) {
        if (this.phones[i].number === "") {
          this.phones[i].number = this.newPhoneInput;
          this.phones[i].code = this.newPhoneLada.value;
          this.countPhone++;
          this.newPhoneInput = "";
          this.newPhoneLada = { value: "+52", text: "🇲🇽 +52" };
          return;
        }
      }
    },
    deletePhone(index) {
      // Validar que quede al menos un teléfono
      if (this.activePhones.length <= 1) {
        Swal.fire({
          title: "No es posible eliminar",
          text: "Debe existir al menos un número de teléfono",
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (this.isEdit && this.phones[index].uuid != "") {
        Swal.fire({
          title:
            "¿Estás seguro de que deseas eliminar este teléfono " +
            this.phones[index].number +
            "?",
          text: "Esta acción no se puede deshacer",
          type: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            let aux = this;
            Axios.delete(
              Servers.serverApi + "api/phones/" + aux.phones[index].uuid,
              {
                responseType: "application/json",
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                },
              }
            )
              .then(function (response) {
                aux.phones[index].number = "";
                aux.phones[index].uuid = "";
                aux.countPhone--;
              })
              .catch(function (error) { });
          }
        });
      } else {
        this.countPhone--;
        this.phones[index].number = "";
      }
    },
    async putResident() {
      var uuid = this.residentValue.uuid;

      var jsonAux = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        idZone: this.zoneModel.value,
        idStreet: this.streetModel.value,
        number: this.form.numberStreet,
        intNumber: this.intNumber,
        useapp: this.useApp,
        action: this.isMe.frac == "Club Tres Marias" ? this.Naccion : null,
        email: this.form.email,
        notresident: false,
      };

      var auxPhone = [];

      for (var i = 0; i < this.phones.length; i++) {
        if (this.phones[i].number != "") {
          if (this.phones[i].uuid != "") {
            auxPhone.push({
              phone: this.phones[i].number,
              code: this.phones[i].code || "+52",
              uuid: this.phones[i].uuid,
            });
          } else {
            auxPhone.push({
              phone: this.phones[i].number,
              code: this.phones[i].code || "+52",
            });
          }
        }
      }
      jsonAux["phones"] = auxPhone;

      try {
        this.isLoading = true;

        let response = await this.editResident({ uuid: uuid, body: jsonAux });

        this.isLoading = false;
        this.showMessageSucces("Residente actualizado correctamente");
      } catch (error) {
        this.isLoading = false;
        this.showMessageError(
          "No se pudo actualizar",
          error.response.data.error_description
        );
        console.log(error.response.data);
      }
    },
    async postResident() {
      var data = [];
      var jsonAux = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        idFrac: this.userMe.idFrac,
        idStreet: this.streetModel.value,
        number: this.form.numberStreet,
        intNumber: this.intNumber,
        useapp: this.useApp,
        action: this.isMe.frac == "Club Tres Marias" ? this.Naccion : null,
        notresident: false,
        email: this.form.email,
      };

      var auxPhone = [];

      for (var i = 0; i < this.phones.length; i++) {
        if (this.phones[i].number != "") {
          auxPhone.push({
            phone: this.phones[i].number,
            code: this.phones[i].code || "+52",
          });
        }
      }
      jsonAux["phones"] = auxPhone;
      data.push(jsonAux);

      try {
        this.isLoading = true;
        let response = await this.createResident(data);

        this.isLoading = false;
        this.showMessageSucces("Residente creado correctamente");
      } catch (error) {
        this.isLoading = false;
        this.showMessageError(
          "No es posible registrar más residentes",
          error.response.data.error_description
        );
        console.log(error.response.data);
      }
    },
    showMessageError: function (text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        type: "error",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => { },
      });
    },
    showMessageSucces: function (text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
        onClose: () => {
          this.remove();
        },
      });
    },
    showMessageInvalidEmail: function (text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Reactivación de correo</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        //icon: "info",
        type: "question",
        width: "30%",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Activar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn-modal-accept",
          cancelButton: "btn-modal-cancel"
        },

      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.reactivateEmail(this.form.email);
        }
      });
    },
    async signalChange(event) {
      if (!event.target.files.length) return;

      this.residentsFile = event.target.files[0];
      const data = new FormData();
      data.append("file", this.residentsFile);

      Swal.fire({
        title: "<span style='font-size: 20px;'> Archivo listo para cargar</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept",
        },
      }).then(async () => {
        try {
          // Mostrar modal de carga
          Swal.fire({
            title: "Cargando residentes...",
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });

          // Realizar la solicitud
          const response = await Axios.post(
            `${Servers.serverApi}api/residents/importResidents/`,
            data,
            {
              responseType: "json",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              },
            }
          );

          if (response.status === 206) {
            await this.handlePartialError(response.data);
          } else if (response.status === 200) {
            await Swal.fire({
              title: "Éxito",
              text: response.data.description || "Operación exitosa.",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.closeModal();
            this.remove();
          }
        } catch (error) {
          console.error("Error en la solicitud:", error);
          await Swal.fire({
            title: "Error",
            text: error.response.data || "Ocurrió un error inesperado.",
            type: "error",
            confirmButtonText: "Cerrar",
          });
        } finally {
          Swal.close(); // Asegurar que el modal de carga siempre se cierra
          this.residentsFile = null; // Liberar la referencia al archivo
          event.target.value = "";
        }
      });
    },

    async handlePartialError(base64Data) {
      if (!base64Data) {
        await Swal.fire({
          title: "Error",
          text: "No se pudo generar el archivo de errores.",
          icon: "error",
          confirmButtonText: "Cerrar",
        });
        return;
      }

      // Decodificar Base64 y crear Blob
      const blob = this.decodeBase64ToBlob(
        base64Data,
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );

      await Swal.fire({
        title: "Error Parcial",
        text: "Algunos registros fallaron. Descarga el archivo para más detalles.",
        icon: "warning",
        confirmButtonText: "Descargar",
        allowOutsideClick: false,
      }).then(() => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Errores.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    decodeBase64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      return new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
    },

    handleShowModal() {
      this.getAllStreets();
      this.showModal = true;
    },
  },
  async created() {
    this.getZones();
    await this.$store.dispatch("fetchFracCapabilities");
  },
  mounted() {
    this.getOneResident();
  },
  update() { },
  watch: {
    zoneModel(newZone) {
      this.zoneModel = newZone;
      if (newZone.value) {
        this.zoneValid = false;
        this.getStreets(newZone.uuid);
      } else {
        this.zoneValid = true;
      }
    },
    streetModel(newStreet) {
      this.streetModel = newStreet;
      if (newStreet.value) {
        this.streetValid = false;
      } else {
        this.streetValid = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      isMe: "getWhoAmi",
      isEdit: "getEditResident",
      residentValue: "getResidentValue",
      userMe: "getUserInfo",
      hasFacialRecognition: "hasFacialRecognition",
    }),
    activePhones() {
      return this.phones.filter(phone => phone.number !== "");
    },
    ladaOptions() {
      return COUNTRY_CODES.map(c => ({ value: c.code, text: `${c.flag} ${c.code}` }));
    },
    newPhoneLadaDigits() {
      const country = COUNTRY_CODES.find(c => c.code === this.newPhoneLada.value);
      return country ? country.digits : 10;
    },
    editingPhoneLadaDigits() {
      const country = COUNTRY_CODES.find(c => c.code === this.editingPhoneCode.value);
      return country ? country.digits : 10;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.Datos-del-registro {
  width: auto;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}

.text-width {
  width: auto;
}

.text-input {
  width: auto;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-final {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}

.style_BTN_phone {
  object-fit: contain;
}

.modal-header {
  background-color: #67a3cf;
  margin-bottom: 20px;
  margin-top: -20px;
}

.face-upload-area {
  margin-top: 10px;
}

.face-upload-placeholder {
  border: 2px dashed #e8e9ec;
  border-radius: 8px;
  padding: 30px 15px;
  text-align: center;
  background-color: #fafbfc;
  cursor: pointer;
  transition: all 0.3s ease;
}

.face-upload-placeholder:hover {
  border-color: #67a3cf;
  background-color: #f0f7fc;
}

.face-upload-disabled {
  cursor: not-allowed;
  opacity: 0.7;
  border-color: #e0e0e0;
  background-color: #f5f5f5;
}

.face-upload-disabled:hover {
  border-color: #e0e0e0;
  background-color: #f5f5f5;
}

.face-upload-disabled-msg {
  font-family: OpenSans-Regular;
  font-size: 11px;
  color: #e8943a;
  margin-top: 5px;
  text-align: center;
  line-height: 1.4;
}

.face-upload-icon {
  font-size: 40px;
  color: #67a3cf;
  margin-bottom: 10px;
}

.face-upload-text {
  font-family: OpenSans-Semibold;
  font-size: 13px;
  color: #5d6078;
  margin: 5px 0;
}

.face-upload-hint {
  font-family: OpenSans-Regular;
  font-size: 11px;
  color: #a09c9c;
}

.face-loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
}

.face-loader-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e8e9ec;
  border-top: 4px solid #67a3cf;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.face-loader-text {
  font-family: OpenSans-Regular;
  font-size: 13px;
  color: #67a3cf;
  margin: 0;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.face-preview-selected {
  margin-top: 15px;
  border: 1px solid #e8e9ec;
  border-radius: 8px;
  padding: 15px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.face-preview-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 15px;
}

.face-preview-img-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.face-preview-img-container:hover {
  transform: scale(1.02);
}

.face-preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  pointer-events: none;
}

.face-preview-img-container:hover .face-preview-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  pointer-events: auto;
}

.face-preview-zoom-icon {
  font-size: 32px;
  color: #ffffff;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.face-preview-img-container:hover .face-preview-zoom-icon {
  opacity: 1;
}

.face-image-preview {
  position: relative;
  margin-top: 10px;
  border: 1px solid #e8e9ec;
  border-radius: 8px;
  padding: 15px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.face-preview-header {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 5px;
  z-index: 10;
}

.face-action-btn {
  width: 32px;
  height: 32px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e8e9ec !important;
}

.face-action-btn:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.face-edit-btn {
  background-color: #67a3cf !important;
  border-color: #67a3cf !important;
}

.face-edit-btn:hover {
  background-color: #5591ba !important;
  border-color: #5591ba !important;
}

.face-edit-btn i {
  color: #ffffff !important;
}

.face-preview-img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #67a3cf;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.face-image-info {
  width: 100%;
  text-align: center;
}

.face-filename {
  font-family: OpenSans-Semibold;
  font-size: 11px;
  color: #5d6078;
  margin: 5px 0;
  word-break: break-word;
}

.face-label-status {
  font-size: 14px;
  margin-left: 5px;
}

.face-status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-family: OpenSans-Semibold;
  font-size: 10px;
  text-transform: uppercase;
}

.face-status-badge.status-approved {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.face-status-badge.status-pending {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.face-status-badge.status-rejected {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.face-status-badge.status-ready {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.phones-chip-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  margin-bottom: 5px;
}

.phone-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #e3f2fd;
  border: 1px solid #67a3cf;
  border-radius: 16px;
  padding: 5px 12px;
  font-family: OpenSans-Regular;
  font-size: 12px;
  color: #026ab4;
  transition: all 0.2s ease;
}

.phone-chip:hover {
  background-color: #bbdefb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.phone-chip-icon {
  font-size: 12px;
  color: #67a3cf;
}

.phone-chip-number {
  font-family: OpenSans-Semibold;
  font-size: 12px;
}

.phone-chip-edit-icon {
  font-size: 11px;
  color: #67a3cf;
  cursor: pointer;
  margin-left: 4px;
  transition: color 0.2s ease;
}

.phone-chip-edit-icon:hover {
  color: #026ab4;
}

.phone-chip-delete {
  font-size: 14px;
  color: #ed5f5f;
  cursor: pointer;
  margin-left: 4px;
  transition: color 0.2s ease;
}

.phone-chip-delete:hover {
  color: #d32f2f;
}

.phone-chip-edit-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 4px;
}

.lada-select-sm {
  height: 30px;
  font-size: 11px;
  padding: 0 4px;
  flex-shrink: 0;
}

.phone-edit-confirm {
  font-size: 16px;
  color: #00a65a;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.phone-edit-confirm:hover {
  color: #008d4c;
}

.phone-edit-cancel-icon {
  font-size: 16px;
  color: #ed5f5f;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.phone-edit-cancel-icon:hover {
  color: #d32f2f;
}

.phone-input-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lada-model-select {
  min-width: 110px;
  max-width: 110px;
  flex-shrink: 0;
  font-size: 12px;
}

.lada-model-select-sm {
  min-width: 95px;
  max-width: 95px;
}

.phone-input {
  flex: 1;
  margin-bottom: 0 !important;
}

/* Eliminar flechas del input number en Chrome, Safari, Edge */
.phone-input::-webkit-outer-spin-button,
.phone-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Eliminar flechas del input number en Firefox */
.phone-input[type=number] {
  -moz-appearance: textfield;
}

/* Estilos para el modal de pantalla completa */
.fullscreen-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fullscreen-preview-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullscreen-close-btn {
  position: absolute;
  top: -50px;
  right: 0;
  background-color: transparent;
  border: none;
  color: #ffffff;
  font-size: 32px;
  cursor: pointer;
  padding: 10px;
  transition: transform 0.2s ease, color 0.2s ease;
  z-index: 10000;
}

.fullscreen-close-btn:hover {
  transform: scale(1.2);
  color: #ff7761;
}

.fullscreen-preview-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  animation: zoomIn 0.3s ease;
}

@keyframes zoomIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
<style scoped>
.inputPhone>input:first-child {
  height: 37px !important;
}
</style>
